import React from 'react';

import { InfoSideBar } from '@/components/mui/info-side-bar';

import { SignInSignOutButton } from '../sign-in-sing-out-button';

export function AppSideBar() {
  return <InfoSideBar footer={<SignInSignOutButton />} />;
}
